import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useSelector } from "react-redux";
import WarningIcon from '@mui/icons-material/Warning';
 
const YourProjectLayout = ({ data }) => {
  const theme = useSelector((data) => data.themeValue.colors)
 
  return (
    <>
      <Box sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        px: 2,
        py: 1,
        backgroundColor: theme.background,
        borderRadius: 1,
        boxShadow: 1
      }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            color: theme.text,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: 1
          }}
        >
          Project Layout
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <WarningIcon sx={{ color: theme.normal_icon }} />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: "20px",color:theme.text }}
          >
            Not scaled
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "80vh", // Set a fixed height or use min-height
          backgroundColor: "#F5F5F5",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <TransformWrapper
          options={{
            limitToBounds: true,
            centerContent: true,
          }}
          doubleClick={{ disabled: false }}
          wheel={{ disabled: true }}
          pinch={{ disabled: true }}
          panning={{ disabled: false }}
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              {/* Zoom Controls */}
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  display: "flex",
                  flexDirection: "column",
                  gap: {
                    xs: 0,
                    sm: 0,
                    md: 1,
                  },
                  zIndex: 10,
                  backgroundColor: theme.background,
                  borderRadius: 1,
                  boxShadow: 2,
                  p: 1,
                }}
              >
                <Tooltip title="Zoom In">
                  <IconButton onClick={() => zoomIn()} size="small" sx={{ color: theme.normal_icon, fontSize: { xs: "10px", } }}>
                    <ZoomInIcon sx={{ fontSize: { xs: "10px", md: "20px", } }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Zoom Out">
                  <IconButton onClick={() => zoomOut()} size="small" sx={{ color: theme.normal_icon }}>
                    <ZoomOutIcon sx={{ fontSize: { xs: "10px", md: "20px" } }} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Reset Zoom">
                  <IconButton onClick={() => resetTransform()} size="small" sx={{ color: theme.normal_icon }}>
                    <RestartAltIcon sx={{ fontSize: { xs: "10px", md: "20px" } }} />
                  </IconButton>
                </Tooltip>
              </Box>
             
              {/* Main Content Area */}
              <Box
                sx={{
                  width: "100%",
                  height: "100%", // Take full height of parent
                  position: "relative",
                  overflow: "hidden",
                  cursor: "grab",
                  backgroundColor: "#F5F5F5"
                }}
              >
                <TransformComponent
                  wrapperStyle={{
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <img
                    src={data.layout_url}
                    alt="Layout Plan"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain", // This will maintain aspect ratio
                      userSelect: "none"
                    }}
                  />
                </TransformComponent>
              </Box>
            </>
          )}
        </TransformWrapper>
      </Box>
    </>
  );
};
 
export default YourProjectLayout;